<template>
	<div class="search_page">
		<div class="search_container">
			<div class="search_box">
				<input type="search" class="search_input" placeholder="请输入关键字" v-model="inputkeyword" @keypress.enter="searchClick">
				<btn class="search_btn" @click="searchClick"><i class="cei-icon icon-search "></i></btn>
			</div>
		</div>


		<div class="w1"><!--w1 -->




			<div class="wrap_group1  mb_1"><!--wrap_group1 -->
				
				<div class="wrap_group1_R"><!--wrap_group1_R -->


					<div class="main_title">{{selName}}</div>

					<ul class="main_list1" v-loading="loadingMask"><!--main_list1 -->
						<li v-for="(item,index) in resultDataList">
							<data>
								<div class="d1">{{item.publishTime.substring(8,10)}}</div>
								<div class="d2">{{item.publishTime.substring(0,7)}}</div>
							</data>
							<cont>
								<h1><router-link :to="'detail?id='+item.id" target="_blank">{{ item.title }}</router-link></h1>
								<div class="source">{{item.source}}</div>
								<div class="info">{{item.content}}</div>
							</cont>
						</li>
					</ul><!--/main_list1 -->

					<div class="Page">
						<el-pagination background @size-change="changePageSize" @current-change="changeSearchPage"
							:current-page="pageNum" :page-size="pageSize" layout="total, prev, pager, next, jumper"
							:total="totalResultCount">
						</el-pagination>
					</div>

				</div><!--/index_group1_R -->
			</div><!--/wrap_group1 -->



		</div><!--/w1 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				inputkeyword:'',
				keyword:'',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		components: {

		},
		watch: {
			$route(to, from) {
				if (to.query.key != from.query.key) {
					this.initSearch();
				}
			}
		},
		created: function() {
			this.initSearch();
		},
		mounted: function() {
			
		},
		methods: {
			initSearch:function(){
				this.keyword = this.$route.query.key;
				this.inputkeyword=this.keyword;
				this.pageNum=1;
				this.getArticleList();
			},
			searchClick: function(){
				if(!this.inputkeyword||this.inputkeyword.trim()==''){
					this.$alert('请输入关键词！', '提示');
					return false;
				}
				const pattern = /[<>"'&]/;
				if(pattern.test(this.inputkeyword)){
					this.$alert('请勿输入特殊字符。(<>"\'&)', '错误');
					return false;
				}
				this.$router.push('/search?key='+encodeURIComponent(this.inputkeyword));
			},
			getArticleList: function() {
				this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: 'chinaculturalindustrypromotion/tbapparticleinfo/list',
						responseType: 'json',
						params: {
							searchKey: this.keyword,
							pageIndex: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							_this.resultDataList = response.data.list.data;
							_this.totalResultCount = response.data.list.totalcount;
						} else {
							_this.resultDataList = [];
							_this.totalResultCount = 0;
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.resultDataList = [];
						_this.totalResultCount = 0;
						_this.loadingMask = false;
						console.log('数据获取出错！');
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getArticleList();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.getArticleList();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},

		}
	}
</script>

<style>
</style>